import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createNestedCrudEndpoints,
} from '@/core/utils'
import { TProjectManagement, TInvoice, TPaymentInvoice } from '.'
import { DataWithPagination, TBaseCatalogs } from '@/core/types'
import { TCustomer } from '../customers'
import api from '@/core/config/axios'
import { AxiosRequestConfig } from 'axios'

export type TProjectsManagement = DataWithPagination<TProjectManagement>
export type TInvoices = DataWithPagination<TInvoice>
export type TPaymentsInvoice = DataWithPagination<TPaymentInvoice>

export const serviceConfig = {
  model: 'projects',
  version: 'v1',
  invoices: {
    model: 'invoices',
    version: 'v1',
  },
  payments: {
    model: 'payments',
    version: 'v1',
  },
  catalogs: {
    customers: {
      model: 'customers',
      version: 'v1',
    },
    categories: {
      model: undefined,
      version: 'v1',
    },
  },
}

const { customers, categories } = serviceConfig.catalogs
const { model: modelInvoices, version: versionInvoices } =
  serviceConfig.invoices
const { model: modelPaymentsInvoice, version: versionPaymentsInvoice } =
  serviceConfig.payments

const moduleServiceHandlers = {
  ...createCrudEndpoints<TProjectsManagement, TProjectManagement>(
    serviceConfig.model,
    serviceConfig.version,
  ),
  actionUploadPo: async (
    payload: FormData,
    id?: number,
    config?: AxiosRequestConfig<FormData>,
  ): Promise<TProjectManagement> =>
    await api
      .post(
        `${serviceConfig.version}/${serviceConfig.model}/${id}/upload-po`,
        payload,
        config,
      )
      .then((response) => response.data),
}

const invoicesServiceHandlers = {
  ...createNestedCrudEndpoints<TInvoices, TInvoice>(
    serviceConfig.model,
    modelInvoices,
    versionInvoices,
  ),
}

const paymentsInvoicesService = createNestedCrudEndpoints<
  TPaymentsInvoice,
  TPaymentInvoice
>(modelInvoices, modelPaymentsInvoice, versionPaymentsInvoice)

const customersServiceHandlers = createCatalogEndpoint<TCustomer[]>(
  customers.model,
  customers.version,
)

const categoriesCatalog = createCatalogEndpoint<TBaseCatalogs>(
  categories.model,
  categories.version,
)

const catalogServiceHandlers = {
  customersServiceHandlers,
  categoriesCatalog,
}

export {
  moduleServiceHandlers,
  catalogServiceHandlers,
  invoicesServiceHandlers,
  paymentsInvoicesService,
}
